import { IEvent } from 'app/api/event/model'
import { IActivityEvent } from '../../../CreateEvent/type'
import { ApproveMemberLayout } from './ApprovedMember'
import { ApproveTeamLayout } from './ApprovedTeam'

export const ApproveLayout = ({ item, event }: { item: IActivityEvent, event?: IEvent }) => {
  return (
    <>
      {event?.isHaveTeam ? (
        <ApproveTeamLayout item={item} />
      ) : (
        <ApproveMemberLayout item={item} />
      )}
    </>
  )
}
